angular.module('impactx.approval').controller('ApprovalListDoneCtrl', ['$scope', 'selectedListItems', '$redirect', '$controller', '$mdDialog', ApprovalListDoneCtrl]);

function ApprovalListDoneCtrl($scope, selectedListItems, $redirect, $controller, $mdDialog) {
    var mainCtrl = $controller('ApprovalListCtrl', {
        selectedListItems: selectedListItems,
        $redirect: $redirect,
        $mdDialog: $mdDialog
    });

    var buttonDefinition = [
        {
            label: "details",
            action: mainCtrl.redirectToDetail,
            type: 'dialogaction',
            condition: selectedListItems.isSingleSelection,
            process: 'ApprovalList'
        }
    ];

    function getItemExpansionEntryPoint(row) {
        return '/approval/atioverview';
    }

    function getItemExpansionParamsFunction(row) {
        return {atiId: row.id};
    }

    function getItemExpansionTemplate(row) {
        return 'modules/approval/templates/approval-itemexpansion.html';
    }

    mainCtrl.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/approval/templates/approvallist.row.tmpl.html',
        filtersTemplate: 'modules/approval/templates/approvallist.filters.tmpl.html',
        isSelectAble: true,
        endpoint: '/approval/list/done',
        ctrl: mainCtrl,
        id: "approvallist",
        excelExport: true,
        itemExpansion: {
            entryPointFunction: getItemExpansionEntryPoint,
            paramsFunction: getItemExpansionParamsFunction,
            templateUrlFunction: getItemExpansionTemplate,
            canExpandFunction: mainCtrl.canExpand
        }
    };

    this.getMeta = function () {
        return mainCtrl.meta;
    };

    mainCtrl.status = "done";
    $scope.$watch(function () {
        return mainCtrl.status;
    }, function (current, original) {
        if (current == "open")
            $redirect.redirectTo(null, "/approvallistopen");
    });
}